import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { prototypeNavigate } from '../utils/prototypeNav';
import { ContentNote } from './ContentNote';
interface Crumb {
  label: string;
  href?: string;
  onClick?: () => void;
}
export function Breadcrumbs({
  items,
  showNote = true
}: {
  items: Crumb[];
  showNote?: boolean;
}) {
  return <nav aria-label="Breadcrumb" className="relative py-2.5" data-id="element-4" data-mp="2m6tj3wolfckk">
      <ol className="flex flex-wrap items-center gap-1 text-xs" data-id="element-5" data-mp="1yfp9ct95qlv9">
        {items.map((item, i) => <li key={item.label} className="flex items-center gap-1" data-id="element-6" data-mp="1ufx70yacxbyc" data-mpi={i}>
            {i > 0 && <ChevronRightIcon className="h-3 w-3 text-brand-muted" aria-hidden="true" data-id="element-7" data-mp="28f6aqyhdmdlf" />}
            {item.href ? <a href={item.href} onClick={e => {
          e.preventDefault();
          if (item.onClick) item.onClick();else prototypeNavigate(item.label, item.href as string);
        }} className="text-brand-skyDark hover:underline" data-id="element-8" data-mp="23faexmiu1sgy">
                {item.label}
              </a> : <span aria-current="page" className="font-medium text-brand-ink" data-id="element-9" data-mp="q7mfs99ol9nw">{item.label}</span>}
          </li>)}
      </ol>
      {showNote && <ContentNote kind="dynamic" detail="Built from URL. Parent = Metro page." className="right-0 top-1 hidden md:block" data-id="element-10" data-mp="106ttixkbv6bj" />}
    </nav>;
}